<template>
    <v-tooltip
        :disabled="!icon.description || !icon.description(value, item)"
        top>
        <template v-slot:activator="{ on, attrs }">
            <a class="icon--button disabled">
                <v-icon
                    v-if="icon.icon"
                    :color="icon.color && icon.color(value, item)"
                    v-bind="attrs"
                    v-on="on"
                >{{ icon.icon(value, item) }}
                </v-icon>
                <img
                    v-else-if="icon.src"
                    :src="icon.src(value, item)"
                    v-bind="attrs"
                    v-on="on"
                >
            </a>
        </template>
        <span v-if="icon.description">{{ icon.description(value, item) }}</span>
    </v-tooltip>
</template>

<script>
export default {
    name: "VueDataTableIconTooltip",
    props: {
        icon: {
            type: Object,
            default: () => {
            },
        },
        item: {
            type: Object,
            default: () => {
            },
        },
        value: undefined,
        header: {
            type: Object,
            default: () => {
            },
        },
    },
}
</script>

<style scoped>

</style>